var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnlocked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF082"
    },
    d: "M298.756,153.386v8.551h51.307v-8.551c0-80.158-65.211-145.37-145.37-145.37  s-145.37,65.211-145.37,145.37V256h51.307V153.386c0-51.866,42.197-94.063,94.063-94.063S298.756,101.52,298.756,153.386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC64"
    },
    d: "M350.063,367.165V332.96h-34.205v-34.205h-34.205v-34.205h-34.205l0.002-34.205H42.221  c-9.445,0-17.102,7.656-17.102,17.102v239.432c0,9.445,7.658,17.102,17.102,17.102h324.944c9.445,0,17.102-7.658,17.102-17.102  V367.165H350.063z M221.795,379.523v21.846c0,9.445-7.658,17.102-17.102,17.102s-17.102-7.658-17.102-17.102v-21.846  c-10.181-5.925-17.102-16.832-17.102-29.461c0-18.891,15.314-34.205,34.205-34.205s34.205,15.314,34.205,34.205  C238.898,362.691,231.977,373.598,221.795,379.523z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC850"
    },
    d: "M93.528,486.881V247.449c0-9.446,7.658-17.102,17.102-17.102H42.221  c-9.445,0-17.102,7.656-17.102,17.102v239.432c0,9.445,7.658,17.102,17.102,17.102h68.409  C101.186,503.983,93.528,496.326,93.528,486.881z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.267,
    y: 264.551,
    style: {
      fill: "#FFF082"
    },
    width: 34.205,
    height: 34.205
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 350.063,
    y: 196.142,
    style: {
      fill: "#FFFFAA"
    },
    width: 34.205,
    height: 34.205
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.472,
    y: 230.347,
    style: {
      fill: "#FFFFAA"
    },
    width: 34.205,
    height: 34.205
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 315.858,
    y: 264.551,
    style: {
      fill: "#FFF082"
    },
    width: 34.205,
    height: 34.205
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.653,
    y: 230.347,
    style: {
      fill: "#FFF082"
    },
    width: 34.205,
    height: 34.205
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.244,
    y: 230.347,
    style: {
      fill: "#FFF082"
    },
    width: 34.205,
    height: 34.205
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.449,
    y: 264.551,
    style: {
      fill: "#FFF082"
    },
    width: 34.205,
    height: 34.205
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.653,
    y: 298.756,
    style: {
      fill: "#FFF082"
    },
    width: 34.205,
    height: 34.205
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.858,
    y: 332.96,
    style: {
      fill: "#FFF082"
    },
    width: 34.205,
    height: 34.205
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.063,
    y: 367.165,
    style: {
      fill: "#FFF082"
    },
    width: 34.205,
    height: 34.205
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 452.676,
    y: 196.142,
    style: {
      fill: "#FFFFD4"
    },
    width: 34.205,
    height: 34.205
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.574,
    y: 127.733,
    style: {
      fill: "#FFFFD4"
    },
    width: 34.205,
    height: 34.205
  })), /*#__PURE__*/React.createElement("rect", {
    x: 384.267,
    y: 332.96,
    style: {
      fill: "#FFF082"
    },
    width: 34.205,
    height: 34.205
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204.693,307.841c-23.281,0-42.221,18.941-42.221,42.221c0,13.292,6.451,25.838,17.102,33.76v17.547  c0,13.851,11.268,25.119,25.119,25.119s25.119-11.268,25.119-25.119v-17.547c10.652-7.922,17.102-20.468,17.102-33.76  C246.914,326.782,227.974,307.841,204.693,307.841z M217.764,372.595c-2.467,1.435-3.985,4.075-3.985,6.929v21.846  c0,5.01-4.076,9.086-9.086,9.086s-9.086-4.076-9.086-9.086v-21.846c0-2.854-1.517-5.493-3.985-6.929  c-8.213-4.781-13.117-13.204-13.117-22.532c0-14.44,11.748-26.188,26.188-26.188s26.188,11.748,26.188,26.188  C230.881,359.391,225.977,367.814,217.764,372.595z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M342.046,196.142v34.205c0,4.427,3.588,8.017,8.017,8.017h34.205c4.428,0,8.017-3.589,8.017-8.017v-34.205  c0-4.427-3.588-8.017-8.017-8.017h-34.205C345.634,188.125,342.046,191.715,342.046,196.142z M358.079,204.159h18.171v18.171  h-18.171V204.159z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M486.881,188.125h-34.205c-4.428,0-8.017,3.589-8.017,8.017v26.188h-26.188c-4.428,0-8.017,3.589-8.017,8.017v26.188  h-26.188c-4.428,0-8.017,3.589-8.017,8.017v34.205c0,4.427,3.588,8.017,8.017,8.017h34.205c4.428,0,8.017-3.589,8.017-8.017v-26.188  h26.188c4.428,0,8.017-3.589,8.017-8.017v-26.188h26.188c4.428,0,8.017-3.589,8.017-8.017v-34.205  C494.898,191.715,491.309,188.125,486.881,188.125z M410.455,290.739h-18.171v-18.171h18.171V290.739z M444.66,256.534h-18.171  v-18.171h18.171V256.534z M478.864,222.33h-18.171v-18.171h18.171V222.33z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M435.574,169.954h34.205c4.428,0,8.017-3.589,8.017-8.017v-34.205c0-4.427-3.588-8.017-8.017-8.017h-34.205  c-4.428,0-8.017,3.589-8.017,8.017v34.205C427.557,166.365,431.146,169.954,435.574,169.954z M443.591,135.749h18.171v18.171  h-18.171V135.749z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M418.472,324.944h-34.205c-4.428,0-8.017,3.589-8.017,8.017v26.188h-18.171V332.96c0-4.427-3.588-8.017-8.017-8.017h-26.188  v-18.171h26.188c4.428,0,8.017-3.589,8.017-8.017v-34.205c0-4.427-3.588-8.017-8.017-8.017h-26.188v-26.188  c0-4.427-3.588-8.017-8.017-8.017h-34.205c-4.428,0-8.017,3.589-8.017,8.017v26.188h-18.171l0.002-26.188  c0-2.126-0.844-4.165-2.347-5.669c-1.504-1.504-3.542-2.348-5.669-2.348H118.647v-68.944c0-47.446,38.6-86.046,86.046-86.046  s86.046,38.601,86.046,86.047v8.551c0,4.427,3.588,8.017,8.017,8.017h51.307c4.428,0,8.017-3.589,8.017-8.017v-8.551  C358.079,68.809,289.27,0,204.693,0S51.307,68.809,51.307,153.386v68.944h-9.086c-13.851,0-25.119,11.268-25.119,25.119v239.432  c0,13.851,11.268,25.119,25.119,25.119h324.944c13.851,0,25.119-11.268,25.119-25.119V375.182h26.188  c4.428,0,8.017-3.589,8.017-8.017V332.96C426.489,328.533,422.9,324.944,418.472,324.944z M289.67,272.568h18.171v18.171H289.67  V272.568z M342.046,290.739h-18.171v-18.171h18.171V290.739z M289.67,238.363h18.171v18.171H289.67V238.363z M67.34,153.386  c0-75.736,61.616-137.353,137.353-137.353S342.046,77.65,342.046,153.386v0.534h-35.273v-0.534  c0-56.287-45.792-102.079-102.079-102.079S102.614,97.099,102.614,153.386v68.944H67.34V153.386z M376.251,486.881  c0,5.01-4.076,9.086-9.086,9.086H42.221c-5.01,0-9.086-4.076-9.086-9.086V247.449c0-5.01,4.076-9.086,9.086-9.086h197.213  l-0.002,26.188c0,2.126,0.844,4.165,2.347,5.669c1.504,1.504,3.542,2.348,5.669,2.348h26.188v26.188  c0,4.427,3.588,8.017,8.017,8.017h26.188v26.188c0,4.427,3.588,8.017,8.017,8.017h26.188v26.188c0,4.427,3.588,8.017,8.017,8.017  h26.188V486.881z M410.455,359.148h-18.171v-18.171h18.171V359.148z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M196.142,272.568h17.102c4.427,0,8.017-3.589,8.017-8.017c0-4.427-3.589-8.017-8.017-8.017h-17.102  c-4.427,0-8.017,3.589-8.017,8.017C188.125,268.979,191.715,272.568,196.142,272.568z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M169.954,264.551c0-4.427-3.589-8.017-8.017-8.017H76.426c-4.427,0-8.017,3.589-8.017,8.017  c0,4.427,3.589,8.017,8.017,8.017h85.511C166.365,272.568,169.954,268.979,169.954,264.551z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlocked);
export default __webpack_public_path__ + "static/media/unlocked.0915f4ccb271a0a5a7f3dad65cdfe737.svg";
export { ForwardRef as ReactComponent };